import React from 'react';
import { Link } from 'react-router-dom';

function Navbar({ bg, text }) {
  const handleLogout = async () => {
    try {
      await fetch('/logout', {
        method: 'POST',
        credentials: 'include'
      });
    } catch (err) {
      // Ignore errors
    }
    // Redirect to home - backend will show login.html
    window.location.href = '/';
  };

  return (
    <header className="lg:px-16 px-4 bg-white text-gray-900 flex flex-wrap justify-between items-center py-4 shadow-md print:hidden border-b border-gray-200">
      <div className="flex gap-2 font-bold text-xl">
        <Link to={"/"} className="flex gap-2 font-bold text-2xl items-center justify-center">
          <img src="/image.png" alt="logo" className="size-16" />
          <h1 className="">Patel Sangathan</h1>
        </Link>
      </div>

      <label htmlFor="menu-toggle" className="cursor-pointer md:hidden block">
        <svg className="fill-current text-gray-700"
          xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20">
          <title>menu</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
        </svg>
      </label>
      <input className="hidden" type="checkbox" id="menu-toggle" />

      <div className="hidden md:flex md:items-center md:w-auto w-full" id="menu">
        <nav>
          <ul className="md:flex items-center justify-between text-base text-gray-900 pt-4 md:pt-0">
            <li>
              <Link className="md:p-4 py-3 px-0 block hover:text-blue-600 transition-colors" to={"/register"}>
                Register
              </Link>
            </li>
            <li>
              <Link className="md:p-4 py-3 px-0 block hover:text-blue-600 transition-colors" to={"/search"}>
                Search
              </Link>
            </li>
            <li>
              <Link className="md:p-4 py-3 px-0 block hover:text-blue-600 transition-colors" to={"/settings"}>
                Settings
              </Link>
            </li>
            <li>
              <button
                onClick={handleLogout}
                className="md:p-4 py-3 px-0 block hover:text-red-600 transition-colors text-red-500 font-medium"
              >
                Logout
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;

